'use client'

import { ROUTES } from '@/core/constants/routes'
import { UnauthorizedError } from '@/core/types/errors/http-error'
import { Button } from '@/core/ui/atoms/button'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}
export const AppError: React.FC<Props> = ({ error, reset }) => {
  const router = useRouter()

  useEffect(() => {
    if (
      error instanceof UnauthorizedError ||
      error.name === 'UnauthorizedError'
    ) {
      router.replace(ROUTES.home)
    }
  }, [error, router])

  return (
    <div>
      <div>
        <div>
          <Button onClick={reset}>Try Again</Button>

          <Button component={Link} href={ROUTES.home} variant='outlined'>
            Go Home
          </Button>
        </div>

        <div className='text-center'>
          <p className='text-sm text-gray-500'>
            Need additional help?{' '}
            <Link
              href={ROUTES.contactUs}
              className='text-sky-blue font-medium hover:underline'
            >
              Contact us
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
